import { rules } from './rbac-rules';

interface Props {
  role: string;
  perform: string;
  yes: (any) => JSX.Element;
  no: (any) => JSX.Element | null;
  roles?: [string];
  data?: any;
}

const checkIfRolesHavePermission = (rules: any, roles: [string], action: string, data: any) => {
  const hasPermission = [];
  roles.forEach(role => {
    if (checkIfRoleHasPermission(rules, role, action, data)) hasPermission.push(true);
  });

  if (hasPermission.length > 0) return true;
  return false;
};

const checkIfRoleHasPermission = (rules: any, role: string, action: string, data: any) => {
  const roleName = JSON.parse(JSON.stringify(role)).roleName
  const permissions = rules[roleName];
  if (permissions === undefined) return false;

  const staticPermissions = permissions.static;

  if (staticPermissions && staticPermissions.includes(action)) {
    // static rule not provided for action
    return true;
  }

  /* // Used for dynamic permissions, currently not needed 
  const dynamicPermissions = permissions.dynamic;
  
  if (dynamicPermissions) {
    const permissionCondition = dynamicPermissions[action];
    if (!permissionCondition) {
      // dynamic rule not provided for action
      return false;
    }

    return permissionCondition(data);
  }
  */

  return false;
};

export const Can = (props: Props) => {
  return checkIfRolesHavePermission(rules, props.roles, props.perform, props.data) ? props.yes(props.data) : props.no(props.data);
};
